import { all, put, select, takeLatest } from 'redux-saga/effects';
import { CommentsActionTypes } from './comments-actions';
import { AlertActionType } from '@store/alert/alert-action';
import { commentsStore } from './comments-store';
import getCommentsListApi from '@api/clients/comments/get-comments-list';

function* getMessagesListWatcher() {
  try {
    const { currentPage, limit } = yield select(commentsStore);
    const response: { data: Array<object> } = yield getCommentsListApi({ page: currentPage, limit: limit });
    yield put({
      type: CommentsActionTypes.SET_COMMENTS_LIST,
      data: response?.data,
    });
  } catch (error: any) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'در گرفتن اطلاعات لیست پیام ها مشکلی پیش آمده است، لطفا صفحه را مجددا بارگزاری نمایید.',
      severity: 'danger',
    });
  }
}

function* commentsMiddleware() {
  yield all([
    takeLatest(CommentsActionTypes.GET_COMMENTS_LIST, getMessagesListWatcher),
    takeLatest(CommentsActionTypes.GET_EXTENDED_COMMENTS_LIST, getMessagesListWatcher),
  ]);
}

export default commentsMiddleware;
